<template>
  <div class="slide zoom" v-parallax-fit="parallax"></div>
</template>

<script>
export default {
  name: 'slide9',
  data() {
    return {
      parallax: [
        {
          start: 5500,
          end: 6000,
          fromStyle: { transform: 'translateY(-1400px) rotateZ(-3deg)' },
          toStyle: { transform: 'translateY(110px) rotateZ(3deg)' },
          easing: 'linear'
        },
        {
          start: 7000,
          end: 7500,
          fromStyle: { transform: 'translateY(110px) rotateZ(3deg)' },
          toStyle: { transform: 'translateY(1800px) rotateZ(9deg)' },
          easing: 'linear'
        },
      ]
    };
  }
}
</script>

<style lang="scss" scoped>
.slide {
    position: absolute;
    background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/09_Photo.png');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 450px;
    height: 500px;
    left: -230px;
    top: 42vh;
    transition: 0.6s;
    z-index: 4;
    @media(max-width: 600px) {
      width: 200px;
      left: -100px;
      top: calc(50% - 210px);
    }
}
</style>
